import React, { Fragment } from 'react';
import { dataFields } from '../../config/data-fields-config';
import SelectDataEntry from '../data-components/select-data-entry';
import withCopyEdit from '../data-container';
import Verification from '../data-components/verification';
import { DataEntryGroup } from '../data-components/data-entry-group';
import '../../map/map-button.css';
/** Land use options — same as map legend (Slide 8). */
const LAND_USE_OPTIONS = [
    'Residential',
    'Commercial',
    'Mixed Used (Residential / Commercial)',
    'Government buildings, Public Administration',
    'Educational',
    'Cultural',
    'Healthcare Facilities',
    'Hospitality',
    'Recreational',
    'Storage',
    'Religious',
    'Parking',
    'Utility',
    'Formal Parking',
    'Informal Parking',
    'Informal Community Space',
    'Public Square',
    'Unused land',
    'Unidentified',
];
const LandUseView = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const queryParameters = new URLSearchParams(window.location.search);
    const subcat = queryParameters.get("sc");
    const currentLandUse = (((_a = props.building) === null || _a === void 0 ? void 0 : _a.current_landuse_group) && props.building.current_landuse_group[0])
        || ((_b = props.building) === null || _b === void 0 ? void 0 : _b.current_landuse_order)
        || null;
    const originalLandUse = (((_c = props.building) === null || _c === void 0 ? void 0 : _c.typology_original_use) && props.building.typology_original_use[0])
        || ((_d = props.building) === null || _d === void 0 ? void 0 : _d.typology_original_use_order)
        || null;
    const onCurrentLandUseChange = (_slug, value) => {
        props.onChange('current_landuse_group', value ? [value] : null);
    };
    const onOriginalLandUseChange = (_slug, value) => {
        props.onChange('typology_original_use', value ? [value] : null);
    };
    const showOriginalLandUseMap = (e) => {
        var _a;
        e.preventDefault();
        (_a = props.onMapColourScale) === null || _a === void 0 ? void 0 : _a.call(props, 'original_landuse');
    };
    const originalMapActive = props.mapColourScale === 'original_landuse';
    return (React.createElement(Fragment, null,
        React.createElement(DataEntryGroup, { name: "Current Land Use", collapsed: subcat == null || subcat != "1" },
            React.createElement(SelectDataEntry, { title: "", slug: "current_landuse_group", value: currentLandUse, mode: props.mode, copy: props.copy, onChange: onCurrentLandUseChange, tooltip: dataFields.current_landuse_group.tooltip, options: LAND_USE_OPTIONS }),
            React.createElement(Verification, { slug: "current_landuse_group", allow_verify: props.user !== undefined && ((_e = props.building) === null || _e === void 0 ? void 0 : _e.current_landuse_group) !== null && !props.edited, onVerify: props.onVerify, user_verified: props.user_verified.hasOwnProperty("current_landuse_group"), user_verified_as: props.user_verified.current_landuse_group && props.user_verified.current_landuse_group.join(", "), verified_count: (_g = (_f = props.building) === null || _f === void 0 ? void 0 : _f.verified) === null || _g === void 0 ? void 0 : _g.current_landuse_group })),
        React.createElement(DataEntryGroup, { name: "Original (Historical) Use", collapsed: subcat == null || subcat != "2" },
            React.createElement("button", { type: "button", className: `clickable-info-box${originalMapActive ? ' is-active' : ''}`, onClick: showOriginalLandUseMap, title: "Show original land use on the map" }, "Click here to see original land use"),
            React.createElement(SelectDataEntry, { title: dataFields.typology_original_use.title, slug: "typology_original_use", value: originalLandUse, mode: props.mode, copy: props.copy, onChange: onOriginalLandUseChange, tooltip: dataFields.typology_original_use.tooltip, options: LAND_USE_OPTIONS }),
            React.createElement(Verification, { slug: "typology_original_use", allow_verify: props.user !== undefined && ((_h = props.building) === null || _h === void 0 ? void 0 : _h.typology_original_use) !== null && !props.edited, onVerify: props.onVerify, user_verified: props.user_verified.hasOwnProperty("typology_original_use"), user_verified_as: props.user_verified.typology_original_use, verified_count: (_k = (_j = props.building) === null || _j === void 0 ? void 0 : _j.verified) === null || _k === void 0 ? void 0 : _k.typology_original_use }),
            React.createElement(SelectDataEntry, { title: dataFields.typology_original_use_source_type.title, slug: "typology_original_use_source_type", value: (_l = props.building) === null || _l === void 0 ? void 0 : _l.typology_original_use_source_type, mode: props.mode, copy: props.copy, onChange: props.onChange, tooltip: dataFields.typology_original_use_source_type.tooltip, options: dataFields.typology_original_use_source_type.items }))));
};
const LandUseContainer = withCopyEdit(LandUseView);
export default LandUseContainer;
